// extracted by mini-css-extract-plugin
export default {"wrapper":"L0SiG","loaderContainer":"envZT","loaderText":"KIgUX"};